
import { useState, useEffect } from 'react';

export default function MobileFixedCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className={`fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white/95 backdrop-blur-md border-t border-gray-100 shadow-[0_-8px_30px_rgba(0,0,0,0.12)] px-4 py-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] transition-transform duration-300 ${isVisible ? 'translate-y-0' : 'translate-y-full'}`}>
      <a
        href="https://px.a8.net/svt/ejp?a8mat=4AX8OA+BW2OQA+1WP2+6JC82"
        rel="nofollow"
        className="flex items-center justify-center gap-2.5 w-full bg-gradient-to-r from-teal-500 via-teal-600 to-emerald-600 text-white py-4 rounded-2xl font-bold text-[15px] shadow-lg shadow-teal-500/30 active:scale-[0.98] transition-all whitespace-nowrap cursor-pointer relative overflow-hidden group"
      >
        <span className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></span>
        <i className="ri-rocket-2-line text-xl animate-bounce"></i>
        <span>今すぐ無料で口座開設</span>
        <span className="bg-white/20 px-2 py-0.5 rounded-full text-xs ml-1">最大50万円CB</span>
      </a>
      <p className="text-center text-[10px] text-gray-500 mt-1.5">
        <i className="ri-shield-check-line mr-1"></i>
        最短5分で申込完了・口座維持費無料
      </p>
      <img
        border={0}
        width={1}
        height={1}
        src="https://www13.a8.net/0.gif?a8mat=4AX8OA+BW2OQA+1WP2+6JC82"
        alt=""
        style={{ display: 'none' }}
      />
    </div>
  );
}
